// function nextStep(currentStep) {
//   document.getElementById("step" + currentStep).classList.remove("visible");
//   document.getElementById("step" + (currentStep + 1)).classList.add("visible");
// }

// function prevStep(currentStep) {
//   document.getElementById("step" + currentStep).classList.remove("visible");
//   document.getElementById("step" + (currentStep - 1)).classList.add("visible");
// }

jQuery(document).ready(function () {
  // Testimonials Slider Start

  jQuery(".testimonial-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 3,
    arrows: false,
    dots: true,
    swipe: true,
    swipeToSlide: true,
    autoplay: true,
    cssEase: "ease-in-out",
    autoplaySpeed: 5000,
    centerMode: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          infinite: true,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
          centerMode: false,
          arrows: false,
          dots: false,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          centerPadding: "0px",
          centerMode: false,
          arrows: false,
          dots: false,
          autoplaySpeed: 5000,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // Testimonials Slider End

  // 
  
  function getQueryParam(param) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function removeIfExistURLParam() {
    var urlParams = new URLSearchParams(window.location.search);
    var isCustomerPosted = urlParams.get("customer_posted") === "true";

    if (window.location.pathname.includes("/pages/il-frames") && isCustomerPosted) {
        setTimeout(function () {
            document.querySelector('#ContactFooter').querySelector('.newsletter-form__message').remove();
        }, 5000);
    }
  }
  removeIfExistURLParam();
  
  // Check if "redirect_to" exists in the URL
  let redirectTo = getQueryParam("redirect_to");
  
  if (redirectTo) {
      window.location.href = '/' + redirectTo; // Redirect to the given URL
  }

});




jQuery(document).ready(function($) {
  $('.screen-section button.next').on('click', function(e) {
    e.preventDefault();
    
    // Scroll to the top or specific section
    $('html, body').animate({
      scrollTop: $('html').offset().top
    }, 100); // 600ms scroll duration
  });
});

